// extracted by mini-css-extract-plugin
module.exports = {"container":"Patients_container__3l0xx","patients":"Patients_patients__3TpYG","patient":"Patients_patient__115Va","btn":"Patients_btn__xkB64"};